<template lang="html">
  <vs-prompt
    title='Ocultar columnas'
    :active.sync="isPromptActiveLocal"
    :buttons-hidden="true"
  >
    <div class="con-exemple-prompt" style="padding-bottom: 10px;">
      <div class="w-full">
        <ul v-if="multipleRows != null" v-for="(rowTitle, rowName) in multipleRows" class="listRow" style="">
          <h3>{{ rowTitle }}</h3>
          <li v-for="Col in HideableColumns[rowName]">
            <vs-checkbox v-model="isHiddenLocal[rowName][Col.name]">{{ Col.title }}</vs-checkbox>
          </li>
        </ul>
        <ul>
          <li v-for="Col in HideableColumns">
            <vs-checkbox v-model="isHiddenLocal[Col.name]">{{ Col.title }}</vs-checkbox>
          </li>
        </ul>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
export default {
  props: {
    isPromptActive: { type: Boolean, required: true },
    HideableColumns: { required: true },
    isHidden: { type: Object, required: true },
    multipleRows: { type: Object, required: false, default: null }
  }, // PROPS
  data() {
    return {
    }
  }, // DATA
  computed: {
    isPromptActiveLocal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        this.$emit('closePromptColumns', val);
      }
    },
    isHiddenLocal: {
      get() {
        return this.isHidden;
      },
      set(val) {
        console.log(val);
        this.$emit('updatePromptColumns', val);
      }
    },
  }, // COMPUTED
}
</script>

<style lang="scss" scoped>
.listRow {
  margin-bottom: 15px;
}
.listRow li {
  margin-top: 5px;
}
</style>
